export default function digitize(value = '') {
  return String(value).replace(/\D/g, '').replace(/(\d{1})$/, '-$1');
}
